import React from 'react';
import Modal from 'shared/components/modal';
import RequestInstitutionForm from './RequestInstitutionForm';
import RequestReceivedMessage from './RequestReceivedMessage';

export interface RequestInstitutionModalProps {
  userId: string;
  impostorMode: boolean;
  educationPhase?: string;
  firstName?: string;
  closeModal: (identifier: string) => void;
  show: boolean;
  type: string;
  email: string;
  deleteStudent: (userId: string) => void;
  requestInstitution: (values: object) => void;
  requested: boolean;
  // TODO: used in files that import this type
  // eslint-disable-next-line react/no-unused-prop-types
  stateKeyAttribute?: string;
}

export default function RequestInstitutionModal(props: RequestInstitutionModalProps) {
  const handleClose = (): void => props.closeModal('requestInstitution');
  const onSubmit = (values: object): void => {
    props.requestInstitution({
      ...values,
      educationPhase: props.educationPhase,
    });
  };

  return (
    <Modal show={props.show} onClose={handleClose}>
      {props.requested ? (
        <RequestReceivedMessage email={props.email} onClose={handleClose} />
      ) : (
        <RequestInstitutionForm
          userId={props.userId}
          type={props.type}
          handleClose={handleClose}
          deleteStudent={props.deleteStudent}
          impostorMode={props.impostorMode}
          firstName={props.firstName || ''}
          onSubmit={onSubmit}
        />
      )}
    </Modal>
  );
}
